var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-input',{staticClass:"app-date-picker",attrs:{"value":_vm.date,"size":_vm.size,"prefix-icon":"icon-datepicker"}})
}
var staticRenderFns = []

export { render, staticRenderFns }